<template>
  <svg
    viewBox="0 0 9 14"
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :heigth="size"
  >
    <path
      d="M0.844357 12.8333C0.603783 12.6147 0.46875 12.319 0.46875 12.0108C0.46875 11.7026 0.603783 11.4069 0.844357 11.1883L5.41686 6.99998L0.844357 2.86998C0.603783 2.65139 0.46875 2.3557 0.46875 2.04748C0.46875 1.73926 0.603783 1.44357 0.844357 1.22498C0.964434 1.11563 1.10729 1.02884 1.2647 0.969607C1.4221 0.910377 1.59092 0.879883 1.76144 0.879883C1.93196 0.879883 2.10078 0.910377 2.25819 0.969607C2.41559 1.02884 2.55845 1.11563 2.67852 1.22498L8.15519 6.17165C8.27626 6.2801 8.37235 6.40914 8.43792 6.55131C8.5035 6.69348 8.53726 6.84597 8.53726 6.99998C8.53726 7.154 8.5035 7.30648 8.43792 7.44865C8.37235 7.59082 8.27626 7.71986 8.15519 7.82831L2.67852 12.8333C2.55845 12.9427 2.41559 13.0295 2.25819 13.0887C2.10078 13.1479 1.93196 13.1784 1.76144 13.1784C1.59092 13.1784 1.4221 13.1479 1.2647 13.0887C1.10729 13.0295 0.964434 12.9427 0.844357 12.8333Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
import mixinIcon from '../mixinIcon'

export default {
  name: 'arrowRight',
  mixins: [mixinIcon]
}
</script>

<style lang="scss"></style>
